import {
    changePasswordWithCognito,
    CHANGE_PASSWORD_WITH_COGNITO,
} from './changePasswordWithCognito';
import {
    checkInvitationList,
    CHECK_INVITATION_LIST,
} from './checkInvitationList';
import {
    confirmRegistrationWithCognito,
    CONFIRM_REGISTRATION_WITH_COGNITO,
} from './confirmRegistrationWithCognito';
import { confirmPassword, CONFIRM_PASSWORD } from './confirmPassword';
import { forgotPassword, FORGOT_PASSWORD } from './forgotPassword';
import {
    registerInvitedUser,
    REGISTER_INVITED_USER,
} from './registerInvitedUser';
import {
    resendConfirmationWithCognito,
    RESEND_CONFIRMATION_WITH_COGNITO,
} from './resendConfirmationWithCognito';
import { signInWithCognito, SIGN_IN_WITH_COGNITO } from './signInWithCognito';
import {
    signOutWithCognito,
    SIGN_OUT_WITH_COGNITO,
} from './signOutWithCognito';
import { signUpWithCognito, SIGN_UP_WITH_COGNITO } from './signUpWithCognito';
import {
    validateCognitoUserSession,
    VALIDATE_COGNITO_USER_SESSION,
} from './validateCognitoUserSession';
import { GET_USERS } from './getUsers';
import { GET_SESSION_CURRENT_USER } from './getSessionCurrentUser';
import { GET_SESSION_IS_SIGNING_UP } from './getSessionIsSigningUp';
import { GET_SESSION_IS_VALID } from './getSessionIsValid';
import { GET_SESSION } from './getSession';

export const authMutations = {
    changePasswordWithCognito,
    confirmRegistrationWithCognito,
    confirmPassword,
    forgotPassword,
    registerInvitedUser,
    resendConfirmationWithCognito,
    signInWithCognito,
    signOutWithCognito,
    signUpWithCognito,
    validateCognitoUserSession,
};

export const authQueries = {
    checkInvitationList,
};

export const authQueryStrings = {
    CHANGE_PASSWORD_WITH_COGNITO,
    CHECK_INVITATION_LIST,
    CONFIRM_REGISTRATION_WITH_COGNITO,
    CONFIRM_PASSWORD,
    FORGOT_PASSWORD,
    GET_SESSION_CURRENT_USER,
    GET_SESSION_IS_SIGNING_UP,
    GET_SESSION_IS_VALID,
    GET_SESSION,
    GET_USERS,
    REGISTER_INVITED_USER,
    RESEND_CONFIRMATION_WITH_COGNITO,
    SIGN_IN_WITH_COGNITO,
    SIGN_OUT_WITH_COGNITO,
    SIGN_UP_WITH_COGNITO,
    VALIDATE_COGNITO_USER_SESSION,
};
